import {
  DOCK5F_DRILL,
  DOCK6F_DRILL,
  DOOR_WALL_AIO_FOLDER,
  ELECTRONIC_SAW,
  ENGRAVING,
  LABELING,
  LABEL_IMAGE,
  PTP,
  SIDE_HOLE,
} from '@/util/configure'

// 文件管理每个key的含义
export const fileManageFormTextObj = {
  setting_id: '生产线',
  nameArr: '一级文件夹',
  orderCodeAsDirectionName: '导出加工文件按订单号命名',
  [ENGRAVING]: '雕刻机',
  [ELECTRONIC_SAW]: '电子锯',
  [LABELING]: '贴标机',
  [SIDE_HOLE]: '侧孔机',
  [DOCK5F_DRILL]: '五面钻',
  [DOCK6F_DRILL]: '六面钻',
  [DOOR_WALL_AIO_FOLDER]: '门墙柜一体机',
  [PTP]: 'PTP',
  [LABEL_IMAGE]: '贴标图片',
  merge_folder_list: '文件夹合并',
  merge_folder_display_name: '合并名称',
  platePropertyMergeFile: '按照材质颜色厚度合并到子文件夹',
  delimiter: '分隔符',
  fileStartNum: '文件夹数自增起始值',
  subfolderNameStr: '子文件夹合并名称',
  use_category_folder: '根据大板颜色、厚度、材质归为不同文件夹(贴标文件一起)',
  same_size_sheet_cutting_files: '同尺寸大板下料文件放在同一个文件夹',
  label_image_in_nc_folder: '贴标图片跟随贴标文件放在NC文件夹里',
  use_category_size_folder:
    '根据材质，颜色，厚度，大板尺寸归为不同文件夹(贴标文件一起)',
  engraving_front_back_folder: '将雕刻机正/反面文件用不同文件夹放置',
  class_by_workstations: '雕刻机按工位分文件夹',
  new_customize_folder: '自定义文件夹',
  customize_folder_config: '自定义文件夹配置',
}
